import { ReactNode } from "react";
import { SiteFooter } from "src/components/Layout/SiteFooter";
import { SiteHeader } from "src/components/Layout/SiteHeader";
import { Container } from "src/components/Elements/Container";
import { theme } from "src/styles/theme";
import { ThemeBackground } from "src/components/GroupVideoTheme/ThemeBackground";
import { HelpBeacon } from "src/components/HelpBeacon";

type OfflineLayoutProps = {
  disableChat?: boolean;
  children: ReactNode;
};

/**
 * A layout for offline pages. None of the components use in this file should
 * make requests to app/api.
 */
export function OfflineLayout({
  children,
  disableChat = false,
}: OfflineLayoutProps) {
  return (
    <>
      <ThemeBackground allowUnthemed>
        <div className="min-screen-height relative flex flex-col overflow-hidden bg-gray-50">
          <div className="grow">
            <SiteHeader isPublicPage isLoggedIn={false} />
            <Container className="grow">{children}</Container>
          </div>

          <div className="mt-8 mb-8 flex flex-col justify-end">
            <SiteFooter />
          </div>
        </div>
      </ThemeBackground>

      <HelpBeacon disableChat={disableChat} color={theme.colors.logo} />
    </>
  );
}
